// extracted by mini-css-extract-plugin
export default {"root":"myc49J","header":"E95p6f","content":"mn3A2r","mobile":"T9RhPf"};